import sidebar from '@/config/sidebars/admin_hubspot'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminHubspotDeals = {
  index: async(props) => {
    const { default: DealsIndex } = await import('@/vue_widgets/admin/hubspot/deals/index.vue')
    createVueApp(DealsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: DealsShow } = await import('@/vue_widgets/admin/hubspot/deals/show.vue')
    createVueApp(DealsShow, { props, sidebar })
  }
}
